// scm-home-git.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'scm-home-cvs',
  template: require('./scm.home.cvs.html')
})
export class ScmHomeCvsComponent {
  @Input() scm: any;
  @Input() user: any;
  @Input() scmData: any;
  @Input() project: any;
  @Input() protocol: string;
  /** Access instructions built by the parent ScmHomeComponent. */
  @Input() scmAccessText: any;
}
